// extracted by mini-css-extract-plugin
export default {"Wrapper":"wrapper_Wrapper_Jnwof","MainContainer":"wrapper_MainContainer_flZ4Y"};